<template>
  <!-- 关键词列表 -->
  <div>
    <el-row type="flex" align="middle" justify="flex-start">
      <filter-panel
        :data="groups"
        :hideResult="true"
        :simple="true"
        @search="filterChange"
        @change="change"
      ></filter-panel>
      <el-button class="search" type="primary" @click="search">搜索</el-button>
    </el-row>
    <!-- 列表 -->
    <data-list
      :data="data"
      :columns="column"
      :page="page"
      :selection="true"
      :page-size="page.pageSize"
      :tableStyle="{ name: 'mixture' }"
      :headerCellStyle="{ background: '#ECF6FF' }"
      :loading="loading"
      @page-size-changed="pageSizeChanged"
      @page-changed="pageChanged"
      @sort-change="sortChange"
      @selection-change="selectionChange"
    ></data-list>
    <!-- 添加优化 -->
    <div class="add" v-if="isShowBtn">
      <div class="checked">已选中：{{ optimizeListLength }}</div>
      <el-button
        class="button"
        type="primary"
        size="small"
        plain
        @click="addOptimize"
        >添加优化</el-button
      >
    </div>
  </div>
</template>

<script>
import filterPanel from "@/components/iglobalwin/filterPanelNew/filterPanel.vue";
import listPageCreate from "@/mixins/listPageCreate";
import api from "@/backend/apiConfig/apiConfig";
const list = listPageCreate({
  searchConfig: {
    api: api.seo.keywordLists,
    method: "POST",
    config: {
      timeout: 30000
    }
  },
  getQuery(obj, that) {
    return _.assign(obj, { seoSiteId: that.$route.query.id });
  }
});
export default {
  mixins: [list],
  props: {
    column: Array,
    groups: Object,
    isShowBtn: Boolean,
    optimizeListLength: Number
  },
  data() {
    return {};
  },
  methods: {
    change(item, value) {},
    selectionChange(val) {
      this.$emit("selectionChange", val);
    },
    addOptimize() {
      this.$emit("addOptimize");
    },
    search() {
      this.$emit('search')
    }
  },
  components: { filterPanel }
};
</script>

<style scoped lang="scss">
.add {
  padding: 10px 20px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  .button {
    margin-left: 30px;
  }
}
.cell {
  color: #4a4a4a;
}

.search {
  height: 40px;
  margin-top: 10px;
}
</style>
